import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = '/api/promotions/dealer/mystery-shoppers'
const QUERY_KEY = 'mystery-shopper'

export const useGetDealerMysteryShoppers = (params = {}, config = {}) =>
  useQuery(
    [`${QUERY_KEY}s`, params],
    async () => (await axios.get(ENDPOINT, { params })).data,
    config
  )

export const useGetDealerMysteryShopperById = (id, config = {}) =>
  useQuery([QUERY_KEY, id], async () => (await axios.get(`${ENDPOINT}/${id}`)).data, config)

export const useGetDealerMysteryShopperBusinessNames = (search = '', config = {}) =>
  useQuery(
    [`${QUERY_KEY}-business-names`, search],
    async () => (await axios.get(`${ENDPOINT}/business-names`, { params: { search } })).data,
    config
  )

export const useGetDealerMysteryShopperCanSubmit = (config = {}) =>
  useQuery(
    [QUERY_KEY, 'form', 'can-submit'],
    async () => (await axios.get(`${ENDPOINT}/form/can-submit`)).data,
    config
  )

export const usePostDealerMysteryShopper = (config = {}) =>
  useMutation((newData) => axios.post(ENDPOINT, newData), config)

export const usePatchDealerMysteryShopperApprove = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/approve`, updatedData), config)

export const usePatchDealerMysteryShopperReject = (id, config = {}) =>
  useMutation((updatedData) => axios.patch(`${ENDPOINT}/${id}/reject`, updatedData), config)

export const usePostExportDealerMysteryShopper = (config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/export`, null, { responseType: 'blob' }), config)

export const usePostResendSMSDealerMysteryShopper = (id, config = {}) =>
  useMutation(() => axios.post(`${ENDPOINT}/${id}/resend-sms`, null), config)
